import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Input, Row } from 'reactstrap';
import useFormatMessage from '../../../utils/useFormatMessage';

const GirisCikisTarihleri = ({ data, adress_data, vehicleData }) => {
    const { t } = useFormatMessage();
    const initialState = {
        liman_giris: "",
        liman_cikis: "",
        gumruklenme_tarihi: "",
        beyanname_no: "",
        fikfit_giris: "",
        fikfit_cikis: "",
        son_depo_giris: "",
        son_depo_cikis: ""
    };

    const [dataSource, setDataSource] = useState(initialState);

    const formatDate = (date) => {
        try {
            return date ? moment(date).format("DD/MM/YYYY HH:mm") : "";
        } catch (error) {
            console.warn("Date formatting error:", error);
            return "";
        }
    };

    const getPortDetails = (locationStr) => {
        if (!locationStr) return "";
        const s = locationStr.toUpperCase();
        if (s.includes("HAYDARPAŞA") || s.includes("HAYDARPASA")) return "Haydarpaşa (TR)";
        if (s.includes("GEMLİK") || s.includes("GEMLIK")) return "Gemlik (TR)";
        if (s.includes("CENOVA") || s.includes("GENOVA")) return "Cenova (IT)";
        if (s.includes("TANGER") || s.includes("TANGIER")) return "Tanger (MA)";
        if (s.includes("BARSELONA") || s.includes("BARCELONA")) return "Barselona (ES)";
        if (s.includes("KOPER")) return "Koper (SI)";
        if (s.includes("DERİNCE") || s.includes("DERINCE")) return "Derince (TR)";
        if (s.includes("AUTOPORT")) return "Autoport (TR)";
        if (s.includes("GEMİ") || s.includes("GEMI") || s.includes("SEFERDE") || s.includes("TIR")) return "";
        const firstPart = locationStr.split("-")[0].trim();
        return firstPart;
    };

    const isNotWarehouse = (movementName) => {
        const nonWarehouseNames = ['GEMİ', 'DEPO İADE', 'BAYİ DEPO İADE', 'FABRİKA'];
        return nonWarehouseNames.some(name => movementName.includes(name));
    };

    const isWarehouseEntry = (operation) => {
        return operation === "DEPO GİRİŞ" ||
            operation === "GEMİ TAHLİYE" ||
            operation === "İADE OKUTMASI" ||
            operation === "İADE GİRİŞİ" ||
            operation === "TANIMSIZ ARAÇ GİRİŞİ";
    };

    const isWarehouseExit = (movement) => {
        const { movement_name = '', operation = '' } = movement;

        return movement_name.includes('TIR') ||
            operation === "KAPI ÇIKIŞ" ||
            operation === "KAPI ÇIKIŞ TARİHİ/TESLİM TARİHİ YÜKLEME";
    };

    useEffect(() => {
        try {
            if (!adress_data || !Array.isArray(adress_data)) {
                setDataSource(initialState);
                return;
            }

            let lastWarehouseEntry = "";
            let lastWarehouseExit = "";
            let lastExitDate = null;
            let lastFiktifEntry = "";
            let lastFiktifExit = "";
            let lastFiktifExitDate = null;

            const isFiktifWarehouse = (movementName) => {
                if (!movementName) return false;
                const s = movementName.toUpperCase();
                return s.includes("FİKTİF") || s.includes("FIKTIF");
            };

            // Process movements in chronological order
            const sortedMovements = [...adress_data].sort((a, b) =>
                new Date(a.process_date) - new Date(b.process_date)
            );

            sortedMovements.forEach(movement => {
                if (!movement) return;

                const movementName = movement.movement_name || '';

                if (isNotWarehouse(movementName)) {
                    return;
                }

                if (isWarehouseEntry(movement.operation)) {
                    lastWarehouseEntry = movement.process_date;
                    if (isFiktifWarehouse(movementName)) {
                        lastFiktifEntry = movement.process_date;
                    }
                }

                if (isWarehouseExit(movement)) {
                    const currentExitDate = new Date(movement.process_date);
                    if (!lastExitDate || currentExitDate > lastExitDate) {
                        lastWarehouseExit = movement.process_date;
                        lastExitDate = currentExitDate;
                    }
                    if (isFiktifWarehouse(movementName)) {
                        if (!lastFiktifExitDate || currentExitDate > lastFiktifExitDate) {
                            lastFiktifExit = movement.process_date;
                            lastFiktifExitDate = currentExitDate;
                        }
                    }
                }
            });

            // Find gumruk, tahliye (liman giriş) and yukleme (liman çıkış) operations
            const tahliyeOp = sortedMovements.find(op => op.operation === "GEMİ TAHLİYE");
            const tahliyePort = getPortDetails(tahliyeOp?.data) || getPortDetails(tahliyeOp?.movement_name);
            const limanGirisFormatted = tahliyeOp ? `${formatDate(tahliyeOp.process_date)}${tahliyePort ? ` ${tahliyePort}` : ''}` : '';

            const yuklemeIdx = sortedMovements.findIndex(op => op.operation === "GEMİ YÜKLEME");
            const yuklemeOp = yuklemeIdx >= 0 ? sortedMovements[yuklemeIdx] : null;
            const yuklemePort = yuklemeIdx > 0
                ? (getPortDetails(sortedMovements[yuklemeIdx - 1]?.data) || getPortDetails(yuklemeOp?.movement_name) || getPortDetails(yuklemeOp?.data))
                : (getPortDetails(yuklemeOp?.movement_name) || getPortDetails(yuklemeOp?.data));
            const limanCikisFormatted = yuklemeOp ? `${formatDate(yuklemeOp.process_date)}${yuklemePort ? ` ${yuklemePort}` : ''}` : '';

            const gumrukOp = (data && Array.isArray(data)) ? data.find(op => op.operation === "GÜMRÜK İŞLEMİ") : null;
            const customsDate = vehicleData?.customs_clearance_date ||
                gumrukOp?.data?.customs_clearance?.tarih ||
                gumrukOp?.data?.tarih ||
                gumrukOp?.process_date;
            const gumrukFormatted = formatDate(customsDate);
            const beyannameNo = vehicleData?.customs_declaration_no ||
                gumrukOp?.data?.customs_clearance?.["beyanname no"] ||
                gumrukOp?.data?.["beyanname no"] ||
                gumrukOp?.data?.customs_clearance?.beyanname_no ||
                "";

            setDataSource({
                ...initialState,
                liman_giris: limanGirisFormatted,
                liman_cikis: limanCikisFormatted,
                gumruklenme_tarihi: gumrukFormatted,
                beyanname_no: beyannameNo,
                fikfit_giris: formatDate(lastFiktifEntry),
                fikfit_cikis: formatDate(lastFiktifExit),
                son_depo_giris: formatDate(lastWarehouseEntry),
                son_depo_cikis: formatDate(lastWarehouseExit)
            });
        } catch (error) {
            console.error("Error processing data:", error);
            setDataSource(initialState);
        }
    }, [data, adress_data, vehicleData]);

    const renderInput = (label, value) => (
        <Col lg="6">
            <div className="dx-fieldset p-0">
                <div className="dx-field mb-2 row">
                    <div className="dx-field-label col-md-4" style={{ color: "black", fontWeight: "500" }}>
                        {t(label)}
                    </div>
                    <div className="dx-field-value col-md-8">
                        <Input
                            id={`input-${label.toLowerCase().replace(/\s+/g, '-')}`}
                            disabled
                            value={value || ""}
                        />
                    </div>
                </div>
            </div>
        </Col>
    );

    return (
        <Row>
            {renderInput("Liman Giriş", dataSource.liman_giris)}
            {renderInput("Liman Çıkış", dataSource.liman_cikis)}
            {renderInput("Gümrüklenme Tarihi", dataSource.gumruklenme_tarihi)}
            {renderInput("Beyanname No", dataSource.beyanname_no)}
            {renderInput("Fiktif Giriş", dataSource.fikfit_giris)}
            {renderInput("Fiktif Çıkış", dataSource.fikfit_cikis)}
            {renderInput("Son Depo Giriş", dataSource.son_depo_giris)}
            {renderInput("Son Depo Çıkış", dataSource.son_depo_cikis)}
        </Row>
    );
};

export default GirisCikisTarihleri;